import { render, staticRenderFns } from "./loteImportacaoModal.vue?vue&type=template&id=1495c25d"
import script from "./loteImportacaoModal.vue?vue&type=script&lang=js"
export * from "./loteImportacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports